/** API-related constants. Per SOP 06 (adapters) + SOP 09 (logging). */

// Gateway base URL. The dev React server (Vite on :5173) and the
// production storefront (Workers static assets at uyyamadilu.com) both
// call the same gateway hostname. CORS is configured server-side to
// accept both origins.
export const APIBASE = 'https://api.uyyamadilu.com'

export const TIMEOUTS = {
  DEFAULT: 10000,
  SHOPIFYADMIN: 10000,
  SHOPIFYSTOREFRONT: 8000,
  SHIPROCKET: 15000,
  AISENSY: 10000,
  BREVO: 10000,
  ZOHO: 20000, // PDF generation slow
  SUPABASE: 5000,
  RAZORPAY: 10000,
  JUDGEME: 8000
} as const

export const CIRCUITBREAKER = {
  SHIPROCKET: { FAILURETHRESHOLD: 5, RESETSECS: 60 },
  AISENSY: { FAILURETHRESHOLD: 10, RESETSECS: 30 },
  BREVO: { FAILURETHRESHOLD: 5, RESETSECS: 60 },
  ZOHO: { FAILURETHRESHOLD: 3, RESETSECS: 120 },
  SUPABASE: { FAILURETHRESHOLD: 3, RESETSECS: 60 },
  RAZORPAY: { FAILURETHRESHOLD: 5, RESETSECS: 60 }
} as const

export const RATELIMIT = {
  MAXREQUESTSPERMINUTE: 60,
  WINDOWSECS: 60,
  AUTHMAXPERMINUTE: 10, // stricter limit on /api/auth/*
  WEBHOOKMAXPERMINUTE: 200 // generous for legitimate webhooks
} as const

export const LOGLEVEL = {
  DEBUG: 'DEBUG',
  INFO: 'INFO',
  WARN: 'WARN',
  ERROR: 'ERROR',
  FATAL: 'FATAL'
} as const
export type LogLevelKey = keyof typeof LOGLEVEL

/**
 * List-endpoint pagination defaults + bounds.
 * Per SOP 02 §"List Pagination (LOCKED — 2026-05-13)".
 * Used by every list endpoint + the shared usePaginatedList hook.
 */
export const PAGINATION = {
  PAGEDEFAULT: 1,
  PAGESIZEDEFAULT: 25,
  PAGESIZEMAX: 100
} as const
